import { Component } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { DashboardService } from '@app/api/dmc';
import { CsvService } from '@app/core/services/csv.service';
import { AlertService } from '@app/core/services/alert.service';

@Component({
  selector: 'app-dashboard-query-list',
  imports: [],
  templateUrl: './dashboard-query-list.component.html',
  styleUrl: './dashboard-query-list.component.css'
})
export class DashboardQueryListComponent {

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly csvService: CsvService,
    private readonly alertService: AlertService,
  ) {
    this.fetchList();

    this.alertService.open('modal', 'info','dashboard.query.list.downloadinfo');
  }

  public fetchList(): void {
     this.dashboardService.dashboardExportCloseTasksPost({
      jobTime: '20',
      endTime: '1500',
      startTime: '0700'
    },
    'response',
    undefined,
    { httpHeaderAccept: 'text/csv' as any }).subscribe((data: HttpResponse<string>) => {

      const filename = this.getFilenameFromContentDisposition(data.headers.get("content-disposition"));

      this.csvService.createBlob(data.body as string);
      this.csvService.download(filename as string);
    })
  }

  private getFilenameFromContentDisposition(header: string | null): string | null {
    if (!header) return null;

    // First try filename* (RFC5987)
    const filenameStarMatch = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (filenameStarMatch) {
      return decodeURIComponent(filenameStarMatch[1]);
    }

    // Fallback to basic filename
    const filenameMatch = header.match(/filename\s*=\s*"?([^;"]+)"?/i);
    if (filenameMatch) {
      return filenameMatch[1];
    }

    return null;
  }

}
